import React from 'react';

export const Materials = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 9C7.27208 7.4379 15.5 5 15.5 5L21 8.5M2 9C4.14788 10.3668 7.5 12.5 7.5 12.5M2 9C2 11.5384 2 15.5 2 15.5L7.5 19M21 8.5L7.5 12.5M21 8.5V15L7.5 19M7.5 12.5V19"
                stroke="#8A4ED6"
                strokeWidth="1.5"
            />
            <path
                d="M8 9.11719L9.57384 9.99642"
                stroke="#8A4ED6"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11 8.11719L12.5738 8.99642"
                stroke="#8A4ED6"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M14 7.11719L15.5738 7.99642"
                stroke="#8A4ED6"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
